export default function availabilityTimeOptions() {
  let values = [];

  for (var h = 0; h < 24; h++) {
    values.push(...formatHourTimes(h));
  }

  return values;
}

const formatTimeNumber = (value) => {
  return value < 10 ? `0${value}` : value;
};

const formatMinute = (value) => {
  return formatTimeNumber(value);
};

const hourDisplay = (hour) => {
  return hour === 0 ? 12 : hour % 12 || hour;
};

const formatHourTimes = (hour) => {
  const values = [];
  let ampm = hour < 12 ? "am" : "pm";
  for (var m = 0; m < 4; m++) {
    let minute = formatMinute(m * 15);
    let h = hourDisplay(hour);
    let value = `${formatTimeNumber(hour)}:${minute}`,
      label = `${h}:${minute} ${ampm}`;
    values.push({
      value: value,
      label: label,
    });
  }
  return values;
};
